import request from '@/api/request';

export const getGoodsByIds = data => request({url: '/api/Shop/GetDiyGoods', data});
export const getGrouponList = data => request({url: '/api/Shop/GetDiyGroupSplices', data});
export const getSeckillList = data => request({url: '/api/shop/GetDiySecondKillActiviyies', data});
export const getCouponList = data => request({url: '/api/shop/GetDiyCoupons', data});
export const getPointList = data => request({url: '/api/shop/GetDiyRewardsPointsGoods', data});
export const getGiftList = data => request({url: '/api/shop/GetDiyGiftPackages', data});

export const getGoodsDetail = guid => request({url: `/api/Shop/GetGoodsDetailBase/${guid}`, data: {}});
export const getGoodsSku = guid => request({url: `/api/Shop/GetGoodsDetailSku/${guid}`, data: {}});
export const addGoodsCart = data => request({url: `/api/Shop/EditGoodsItemShopCart`, data});
export const getGoodsCart = data => request({url: '/api/Shop/GetShopCarts', data}, {loading: false});

export const getCoupon = params => request({url: '/api/Shop/GetCoupon', data: {params}});
